import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import { routes } from './routes/routes'
import store from './store'
import 'swiper/dist/css/swiper.min.css'
import VueI18n from 'vue-i18n'
import { zh } from './locales/zh/translation'
import { en } from './locales/en/translation'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import './css/main.css'

if (process.env.NODE_ENV === 'development') axios.defaults.baseURL = 'http://localhost:3000'
else axios.defaults.baseURL = 'https://premium.aimatchmaker.com'
axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.prototype.$video = Video
Vue.use(VueI18n)
Vue.use(Vuetify)
Vue.use(VueRouter)
export const router = new VueRouter({
  routes,
  mode: 'history'
})
const messages = {
  en: en,
  zh: zh
}
const i18n = new VueI18n({
  locale: 'zh',
  fallbackLocale: 'zh',
  messages
})
new Vue({ // eslint-disable-line no-new
  el: '#app',
  vuetify: new Vuetify({
    icons: {
      iconfont: 'fa'
    }
  }),
  created () {
    AOS.init({
      duration: 600
    })
  },
  router,
  store,
  i18n,
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  },
  render: h => h(App)
})
